import { range } from "lodash";

export const getOptionsForModelYear = () => {
  return range(new Date().getFullYear() + 1, 1899).map((year) => ({
    value: year,
    label: year.toString(),
  }));
};
